var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProducts = function SvgProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 698 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_479)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "dvc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.402 149.795c-.081.962.515 1.939 1.787 2.674l112.621 65.017c2.393 1.381 6.271 1.381 8.663 0l112.622-65.017c1.272-.735 1.868-1.712 1.787-2.674 2.638 2.338 2.093 5.435-1.343 7.419l-110.9 64.023c-3.588 2.071-9.406 2.071-12.995 0L36.745 157.214c-3.436-1.984-3.981-5.081-1.343-7.419Z",
    fill: "url(#paint0_linear_193_479)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 269.496 73.645)",
    fill: "url(#paint1_linear_193_479)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_d_193_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m151.476 138.008 9.385 15.688-.36.208-29.05-5.812c3.583.818 6.87 1.97 9.739 3.413 4.258 2.041 6.603 4.747 7.477 7.826l28.386 5.468c.649.101 1.182.032 1.632-.228l.563-.325c.439-.254.57-.555.394-.93l-9.541-16.61c-5.072-.613-9.615-2.059-13.104-4.172-2.371-1.369-4.247-2.881-5.533-4.52l.012-.006Z",
    fill: "url(#paint2_linear_193_479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.715 147.273c-7.579.009-13.919-1.614-19.33-4.737-5.43-3.135-8.282-6.796-8.277-11.201-.062-2.11.63-4.202 2.031-6.147 1.402-1.946 3.483-3.702 6.115-5.159 4.789-2.847 11.294-4.521 18.176-4.675 1.069-.023 1.595.269 1.576.839l.162 4.975c-.05.517-.511.783-1.365.788-3.831.109-7.443 1.051-10.11 2.636-1.458.807-2.597 1.786-3.338 2.871-.742 1.085-1.069 2.251-.959 3.418.076 1.17.553 2.322 1.402 3.387.849 1.066 2.054 2.025 3.546 2.823 2.08 1.282 4.778 2.176 7.743 2.565 2.965.389 6.06.255 8.884-.385 1.859-.437 3.535-1.096 4.919-1.935 2.709-1.493 4.368-3.522 4.679-5.7.07-.54.563-.801 1.458-.782l8.732.147c.946.001 1.41.292 1.412.874-.031 1.994-.75 3.962-2.116 5.791-1.365 1.828-3.35 3.479-5.837 4.857-2.517 1.516-5.546 2.719-8.901 3.535-3.355.816-6.966 1.227-10.612 1.209l.01.006Z",
    fill: "url(#paint3_linear_193_479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.091 180.62-36.832-21.264a.998.998 0 0 1-.334-.28.535.535 0 0 1-.11-.334.452.452 0 0 1 .074-.306.83.83 0 0 1 .287-.261l13.163-7.598c5.816-2.881 11.394-4.313 18.893-4.255 7.54.047 13.334 1.686 19.375 4.624 5.803 2.826 8.249 6.755 8.351 11.096.117 2.051-.503 4.093-1.821 5.999-1.311 1.895-3.296 3.61-5.828 5.034l-13.162 7.598a1.566 1.566 0 0 1-.456.17 2.116 2.116 0 0 1-.536.045 2.35 2.35 0 0 1-.574-.067 1.692 1.692 0 0 1-.479-.195l-.011-.006Zm-19.46-20.957 20.714 11.959 5.176-2.988c1.452-.8 2.586-1.772 3.325-2.849.739-1.077 1.064-2.233.954-3.389-.188-2.417-1.99-4.696-5.027-6.362-3.159-1.824-6.836-2.778-10.998-2.89a23.437 23.437 0 0 0-5.867.558c-1.864.426-3.548 1.078-4.939 1.912l-5.165 2.982 1.838 1.062-.011.005Z",
    fill: "url(#paint4_linear_193_479)"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 3.125,
    transform: "scale(1.22477 .70707) rotate(-45 439.558 4.087)",
    fill: "#2E4176"
  })), /*#__PURE__*/React.createElement("g", {
    className: "studio"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.215 299.787c-.081.961.514 1.939 1.786 2.673l112.622 65.017c2.392 1.381 6.271 1.381 8.663 0l112.621-65.017c1.273-.734 1.868-1.712 1.787-2.673 2.639 2.338 2.094 5.434-1.343 7.418l-110.899 64.023c-3.589 2.072-9.407 2.072-12.995 0l-110.899-64.023c-3.437-1.984-3.982-5.08-1.343-7.418Z",
    fill: "url(#paint10_linear_193_479)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 631.627 -76.355)",
    fill: "url(#paint11_linear_193_479)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_d_193_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.746 306.829c.906 2.663-1.63 5.459-6.304 5.258 2.784.115 5.576-.14 8.161-.747 2.567-.603 4.854-1.544 6.679-2.749 1.824-1.204 3.135-2.639 3.829-4.188.702-1.565.776-3.203.216-4.787l-11.801-33.821c-.436-1.095-1.579-2.052-3.194-2.677-1.603-.625-3.562-.868-5.467-.679-.93.093-1.818.292-2.613.585-.795.292-1.482.673-2.021 1.12-1.086.91-1.506 2.031-1.168 3.119a6756.446 6756.446 0 0 1 13.674 39.561l.009.005Z",
    fill: "url(#paint12_linear_193_479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.13 310.383-2.029-5.778c-.924-2.653 1.551-5.445 6.216-5.279 1.193.044 2.413.155 3.635.344l25.448 3.842a6.358 6.358 0 0 0 1.642.034 5.12 5.12 0 0 0 1.486-.379c.437-.191.793-.438 1.037-.721.245-.284.375-.597.38-.917l1.801 5.3c.906 2.663-1.63 5.459-6.304 5.258a32.27 32.27 0 0 1-3.417-.338l-25.447-3.831a6.33 6.33 0 0 0-1.849-.008c-.601.088-1.152.264-1.599.512-.446.247-.774.558-.95.901a1.265 1.265 0 0 0-.058 1.066l.009-.005-.001-.001Z",
    fill: "url(#paint13_linear_193_479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.102 310.288.029.096 7.664 19.674c.202.54.217 1.097.045 1.641-.172.543-.528 1.062-1.048 1.525-1.048.927-2.696 1.569-4.588 1.787-1.912.215-3.895-.008-5.526-.624-1.647-.615-2.821-1.573-3.279-2.674l-7.665-19.674c-.622-1.586-.606-3.234.047-4.816.643-1.566 1.914-3.023 3.712-4.253 1.798-1.23 4.072-2.198 6.638-2.828 2.583-.632 5.386-.912 8.187-.816-4.657-.162-7.14 2.626-6.217 5.279l2.001 5.683Z",
    fill: "url(#paint14_linear_193_479)"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 3.125,
    transform: "scale(1.22477 .70707) rotate(-45 801.689 -145.914)",
    fill: "#2E4176"
  })), /*#__PURE__*/React.createElement("g", {
    className: "mlem"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.308 74.8c-.081.961.515 1.938 1.787 2.673l112.622 65.017c2.392 1.381 6.27 1.381 8.663 0l112.621-65.017c1.272-.735 1.868-1.712 1.787-2.674 2.639 2.338 2.093 5.435-1.343 7.419l-110.9 64.023c-3.588 2.071-9.406 2.071-12.994 0l-110.9-64.023c-3.436-1.984-3.981-5.08-1.343-7.419Z",
    fill: "url(#paint15_linear_193_479)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 194.496 -107.421)",
    fill: "url(#paint16_linear_193_479)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_d_193_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.303 46.804c-5.53-1.85-12.381.326-12.545 3.985l-.668 14.678c-.032.703-.524 1.368-1.378 1.861-.854.493-2.005.777-3.223.796l-25.426.384c-6.337.096-10.103 4.051-6.902 7.243l15.073 15.027c8.252 8.226 24.901 12.362 40.705 10.113 7.147-1.017 13.698-3.069 19.04-5.962 3.389-1.842 4.098-10.11.782-12.026a.896.896 0 0 0-.252-.093 1.174 1.174 0 0 0-.576.024.687.687 0 0 0-.22.112 24.345 24.345 0 0 1-2.833 1.9l-6.221 3.592c-3.687 2.128-8.316 3.634-13.403 4.358-4.635.661-9.547.423-13.983-.68-4.436-1.102-8.151-3.006-10.575-5.422l-8.021-7.994c-.209-.21-.323-.445-.329-.685-.006-.24.095-.475.293-.683.199-.208.488-.382.84-.505a3.751 3.751 0 0 1 1.169-.198l11.466-.173c10.102-.153 18.142-4.795 18.407-10.627l.302-6.62c.011-.239.129-.471.342-.674.213-.203.514-.37.874-.484a3.846 3.846 0 0 1 1.183-.17c.414.004.822.069 1.185.19l13.362 4.467c.823.275 1.606.577 2.35.902.42.18.914.291 1.43.323a4.728 4.728 0 0 0 1.5-.143c2.509-.665 5.276-.959 8.055-.854 2.476.092 5.151-1.621 3.527-2.718-2.779-1.878-6.091-3.47-9.79-4.705l-25.539-8.538h-.001Z",
    fill: "url(#paint17_linear_193_479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.721 77.388c-3.441-1.986-3.435-5.71.799-8.155 3.192-1.843 8.352-1.882 12.052.254 3.699 2.136 3.631 5.114.439 6.957-.653.377-1.171.825-1.524 1.318-.353.493-.533 1.022-.531 1.557.002.534.186 1.064.542 1.559.356.494.877.944 1.534 1.323.657.38 1.436.68 2.293.886a11.71 11.71 0 0 0 2.7.312c.926.001 1.842-.103 2.696-.306.855-.204 1.63-.503 2.282-.88 9.175-5.297 8.237-13.438-.48-18.47-8.718-5.034-22.821-5.575-31.995-.279-8.72 5.034-10.681 13.942-.761 19.67l9.159 5.287c1.408.813 2.335 1.861 2.651 2.994.315 1.133.001 2.292-.897 3.312-.126.142.151.287.347.174l2.074-1.197c6.87-3.966 6.846-10.41-.052-14.393l-3.331-1.923h.003Z",
    fill: "url(#paint18_linear_193_479)"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 3.125,
    transform: "scale(1.22477 .70707) rotate(-45 364.558 -176.98)",
    fill: "#2E4176"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cml"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.215 149.795c-.081.962.514 1.939 1.786 2.674l112.622 65.017c2.392 1.381 6.271 1.381 8.663 0l112.621-65.017c1.273-.735 1.868-1.712 1.787-2.674 2.639 2.338 2.094 5.435-1.343 7.419l-110.899 64.023c-3.589 2.071-9.407 2.071-12.995 0l-110.899-64.023c-3.437-1.984-3.982-5.081-1.343-7.419Z",
    fill: "url(#paint19_linear_193_479)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 375.562 -182.421)",
    fill: "url(#paint20_linear_193_479)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter5_d_193_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.245 139.492c-13.109.029-31.855.069-43.728 6.923-12.925 7.462-13.452 19.269-.474 26.868l.548.317 10.284-5.937-.548-.317c-7.187-4.277-6.624-10.739.61-14.915 6.595-3.808 13.705-3.941 41.525-4.46 4.217-.078 8.432-.168 12.647-.259 6.524-.14 12.003-.257 18.191-3.83 8.385-4.84 8.06-12.876-.435-17.78l-.548-.316-10.285 5.937.549.317c1.316.759 2.297 1.922 2.309 2.989.012 1.067-.711 2.088-2.009 2.838-3.407 1.967-13.169 1.784-20.044 1.656-2.868-.054-5.725-.036-8.592-.031Z",
    fill: "url(#paint21_linear_193_479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.214 148.11c2.247-.045 4.657-.09 7.247-.139 2.562-.048 5.124-.099 7.685-.153l-.006.851c-.048 7.568-.118 18.39-11.991 25.245-12.983 7.495-34.406 7.279-47.559-.314l-.548-.317 10.284-5.937.549.317c7.398 4.271 19.552 4.452 26.855.236 5.981-3.453 6.725-7.151 7.484-19.789Z",
    fill: "url(#paint22_linear_193_479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.971 139.591c-2.473.019-4.949-.027-7.134-.068-2.372-.044-4.737-.04-7.106-.034l.044-1.155c.057-.585.093-1.154.13-1.709.241-3.767.444-6.93 6.632-10.503 8.112-4.683 22.102-4.769 29.78-.336l.548.316-10.284 5.938-.548-.317c-3.291-1.9-7.681-.39-9.075.415-2.324 1.342-2.917 4.39-2.987 7.453Z",
    fill: "url(#paint23_linear_193_479)"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 3.125,
    transform: "scale(1.22477 .70707) rotate(-45 545.624 -251.98)",
    fill: "#2E4176"
  })), /*#__PURE__*/React.createElement("g", {
    className: "tpi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.121 224.791c-.081.962.514 1.939 1.787 2.673l112.621 65.018c2.392 1.381 6.271 1.381 8.663 0l112.621-65.018c1.273-.734 1.868-1.711 1.787-2.673 2.639 2.338 2.094 5.435-1.343 7.419l-110.899 64.023c-3.588 2.071-9.406 2.071-12.995 0L426.464 232.21c-3.437-1.984-3.982-5.081-1.343-7.419Z",
    fill: "url(#paint24_linear_193_479)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 556.628 -257.42)",
    fill: "url(#paint25_linear_193_479)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter6_d_193_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.572 201.2c7.43-3.649 18.86-4.163 27.373-.244l.525.242c6.201 2.854 8.996 7.516 7.172 11.962-1.435 3.5-1.92 7.109-1.438 10.698l1.268 9.449c.276 2.058 3.389 3.602 6.953 3.449 3.564-.154 6.23-1.947 5.953-4.005l-1.268-9.449c-.378-2.818.003-5.652 1.13-8.4 2.979-7.264-1.587-14.879-11.716-19.542l-.526-.242c-19.369-8.918-48.166-3.511-54.652 10.261l-.246.523a16.474 16.474 0 0 1 2.181-1.492c4.703-2.715 11.18-3.785 17.291-3.21Z",
    fill: "url(#paint26_linear_193_479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.893 202.996c-1.659.505-3.216 1.161-4.611 1.966-4.419 2.552-6.234 6.039-5.446 9.363-6.418 4.288-7.357 10.933-.53 15.876l.97.702c4.608 3.336 12.133 4.84 19.311 3.859a120.214 120.214 0 0 1 20.148-1.024l15.944.522c3.57.117 6.308 1.882 6.115 3.942-.192 2.061-3.241 3.636-6.811 3.519l-15.944-.522a98.18 98.18 0 0 0-16.436.836c-12.057 1.648-24.698-.878-32.439-6.482l-.971-.703c-15.446-11.182-6.081-27.806 17.774-31.551l1.098-.173a11.083 11.083 0 0 1 1.828-.13Z",
    fill: "url(#paint27_linear_193_479)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.114 218.866c-4.428-5.263-12.153-9.364-21.607-11.47l4.629-6.971c12.524 2.789 22.755 8.22 28.62 15.192l13.513 16.063c1.563 1.859.224 4.093-2.99 4.99-3.215.897-7.089.118-8.652-1.74l-13.513-16.064Z",
    fill: "url(#paint28_linear_193_479)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M534.625 227.137c-10.008-2.715-17.794-7.577-21.697-13.549l-12.111 2.621c5.096 7.798 15.263 14.146 28.331 17.69l26.798 7.269c3.24.878 7.092.077 8.604-1.791 1.512-1.867.113-4.093-3.126-4.972l-26.799-7.268Z",
    fill: "#13ADC7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.563 201.404c-19.708-6.581-41.963 6.267-30.564 17.645l11.721-3.128c-4.759-4.75 5.483-10.663 13.711-7.915l5.132-6.602Zm30.817 45.988c-.548-2.041 1.872-3.946 5.404-4.257l.56-.049c2.793-.245 4.982-1.509 5.407-3.121l.085-.324c.538-2.039 3.839-3.436 7.373-3.119 3.535.316 5.964 2.226 5.426 4.265l-.086.323c-1.275 4.837-7.842 8.628-16.22 9.365l-.56.049c-3.533.31-6.841-1.092-7.389-3.132Z",
    fill: "#13ADC7"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 3.125,
    transform: "scale(1.22477 .70707) rotate(-45 726.69 -326.98)",
    fill: "#2E4176"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_479",
    x1: 154.142,
    y1: 224.988,
    x2: 154.298,
    y2: 81.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24335C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_193_479",
    x1: 140,
    y1: 0,
    x2: -18.52,
    y2: 114.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F192E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_193_479",
    x1: 152.347,
    y1: 158.218,
    x2: 161.594,
    y2: 174.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E51C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_193_479",
    x1: 172.837,
    y1: 132.979,
    x2: 182.564,
    y2: 149.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_193_479",
    x1: 125.242,
    y1: 160.49,
    x2: 134.962,
    y2: 177.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1497B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_193_479",
    x1: 284.048,
    y1: 299.984,
    x2: 284.204,
    y2: 156.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24335C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_193_479",
    x1: 140,
    y1: 0,
    x2: -18.52,
    y2: 114.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F192E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_193_479",
    x1: 244.156,
    y1: 193.956,
    x2: 242.032,
    y2: 253.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1497B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1497B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13ADC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_193_479",
    x1: 231.505,
    y1: 244.241,
    x2: 326.533,
    y2: 234.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_193_479",
    x1: 266.74,
    y1: 194.984,
    x2: 301.379,
    y2: 254.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#875DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#AE6CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#875DC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_193_479",
    x1: 413.954,
    y1: 374.979,
    x2: 414.111,
    y2: 231.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24335C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_193_479",
    x1: 140,
    y1: 0,
    x2: -18.52,
    y2: 114.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F192E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_193_479",
    x1: 432.425,
    y1: 287.566,
    x2: 444.757,
    y2: 308.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_193_479",
    x1: 401.578,
    y1: 297.613,
    x2: 433.468,
    y2: 310.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E51C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E51C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_193_479",
    x1: 397.317,
    y1: 316.821,
    x2: 406.092,
    y2: 332.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1497B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_193_479",
    x1: 284.048,
    y1: 149.992,
    x2: 284.204,
    y2: 6.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24335C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_193_479",
    x1: 140,
    y1: 0,
    x2: -18.52,
    y2: 114.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F192E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_193_479",
    x1: 300.981,
    y1: 92.532,
    x2: 263.68,
    y2: 75.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E51C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13ADC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_193_479",
    x1: 300.595,
    y1: 82.814,
    x2: 314.259,
    y2: 84.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_193_479",
    x1: 413.954,
    y1: 224.988,
    x2: 414.111,
    y2: 81.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24335C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_193_479",
    x1: 140,
    y1: 0,
    x2: -18.52,
    y2: 114.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F192E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_193_479",
    x1: 386.451,
    y1: 146.603,
    x2: 443.104,
    y2: 145.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13ADC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_193_479",
    x1: 396.955,
    y1: 160.167,
    x2: 433.998,
    y2: 159.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E51C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_193_479",
    x1: 425.121,
    y1: 139.606,
    x2: 425.167,
    y2: 127.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1497B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#13ADC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_193_479",
    x1: 543.861,
    y1: 299.984,
    x2: 544.017,
    y2: 156.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24335C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_193_479",
    x1: 140,
    y1: 0,
    x2: -18.52,
    y2: 114.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F192E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_193_479",
    x1: 506.358,
    y1: 192.273,
    x2: 532.741,
    y2: 230.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46837"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_193_479",
    x1: 523.515,
    y1: 217.18,
    x2: 544.924,
    y2: 246.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13ADC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_193_479",
    x1: 536.259,
    y1: 207.056,
    x2: 545.909,
    y2: 238.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46837"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_479",
    x: 0.235,
    y: 0,
    width: 697.531,
    height: 422.979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0862745 0 0 0 0 0.141176 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_193_479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_193_479",
    x: 89.189,
    y: 111.869,
    width: 130.988,
    height: 77.621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0862745 0 0 0 0 0.141176 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_193_479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_193_479",
    x: 214.765,
    y: 189.434,
    width: 130.868,
    height: 77.551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0862745 0 0 0 0 0.141176 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_193_479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_193_479",
    x: 347.918,
    y: 260.61,
    width: 132.072,
    height: 78.246,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0862745 0 0 0 0 0.141176 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_193_479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_193_479",
    x: 222.343,
    y: 39.373,
    width: 123.411,
    height: 73.246,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0862745 0 0 0 0 0.141176 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_193_479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_193_479",
    x: 349.001,
    y: 112.494,
    width: 129.906,
    height: 76.996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0862745 0 0 0 0 0.141176 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_193_479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_193_479",
    x: 470.247,
    y: 182.49,
    width: 147.227,
    height: 86.995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0862745 0 0 0 0 0.141176 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_193_479",
    result: "shape"
  })))));
};

export { SvgProducts as ReactComponent };
export default __webpack_public_path__ + "static/products.e544cc78.svg";